export default "__VITE_ASSET__tgsieIZh__"